import * as React from 'react';

import styled from 'styled-components';
import SvgIcon from '../SvgIcon';
import Button from '../Button';

interface Props {
  readonly infoTitle: string;
  readonly title: string;
  readonly description: string;
  readonly iconName: string;
  readonly buttonTitle: string;
  readonly onButtonClick: () => void;
}

const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 320px;
  height: 140px;
  justify-content: space-between;
`;

const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const InfoTitle = styled.span`
  font-weight: ${p => p.theme.font.weight.medium};
  font-size: ${p => p.theme.font.size.xSmall};
  color: ${p => p.theme.color.battleshipGrey};
`;

const Title = styled.span`
  font-weight: ${p => p.theme.font.weight.semiBold};
  font-size: ${p => p.theme.font.size.regular};
  color: ${p => p.theme.color.black2};
`;

const Descr = styled.span`
  font-size: ${p => p.theme.font.size.small};
  color: ${p => p.theme.color.battleshipGrey};
  line-height: 1.5;
`;

const IconContainer = styled.div`
  padding-right: 10px;
`;

const ActionButton = styled(Button)`
  width: 170px;
  height: 36px;
  font-size: ${p => p.theme.font.size.small} !important;
`;

export const ToastComponent: React.FunctionComponent<Props> = React.memo(props => {
  return (
    <HorizontalContainer>
      <IconContainer>
        <SvgIcon iconName={props.iconName} iconWidth={80} iconHeight={80} />
      </IconContainer>
      <VerticalContainer>
        <InfoTitle>{props.infoTitle}</InfoTitle>
        <Title>{props.title}</Title>
        <Descr>{props.description}</Descr>
        <ActionButton onClick={props.onButtonClick}>{props.buttonTitle}</ActionButton>
      </VerticalContainer>
    </HorizontalContainer>
  );
});



// WEBPACK FOOTER //
// ./src/components/ToastComponent/index.tsx